import React, { useEffect, useState } from "react"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { ButtonDropdown, TabLog, TabsComponent } from "../../../../../component/index.jsx"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { useTranslation } from "react-i18next"
import { MasterBaseTabDetail } from "./tab/MasterBaseTabDetail.jsx"
import { MasterBaseTabOpsTeam } from "./tab/MasterBaseTabOpsTeam.jsx"
import { BASE_DETAIL_TAB_STRING, BASE_STATUS_ENUM } from "../../../../../constants/StringConstant.js"
import { MasterBaseTabDrone } from "./tab/MasterBaseTabDrone.jsx"
import { ENUM_LOG } from "../../../../../constants/InitTypeConstants.js"

export const MasterBaseDetail = ({ history, match: { params: { id, tab } } }) => {
  const subheader = useSubheader()
  const { t } = useTranslation()
  const [tabActive, setTabActive] = useState(
    tab === BASE_DETAIL_TAB_STRING.DETAIL ? 0 :
      tab === BASE_DETAIL_TAB_STRING.OPS_TEAM ? 1 :
        tab === BASE_DETAIL_TAB_STRING.TEAM_DRONE ? 2 :
          tab === BASE_DETAIL_TAB_STRING.LOG ? 3 : 0
  )

  const btnDropdownList = [
    {
      title: t("label_edit_base"),
      icon: ICON_CONSTANTS.EDIT,
      action: () => {
        history.push(RoutesConstants.MASTER_DATA.BASE.EDIT(id))
      },
      showed: true
    }
  ]

  useEffect(() => {
    subheader.setBreadcrumbs([
      {
        pathname: RoutesConstants.MASTER_DATA.REGIONAL.PAGE(),
        title: t("menu_master_data")
      },
      {
        pathname: RoutesConstants.MASTER_DATA.BASE.LIST(BASE_STATUS_ENUM.ACTIVE),
        title: t("sub_header_base")
      },
      {
        title: t("sub_header_detail_base")
      }
    ])
    subheader.setButton(<ButtonDropdown title={t("table_header_action")} dropdownList={btnDropdownList} />)
    return () => {
      subheader.setBreadcrumbs([])
      subheader.setButton(null)
    }
  }, [])

  const handleTabChange = (index) => {
    setTabActive(index)
    if (index === 0) {
      history.push(RoutesConstants.MASTER_DATA.BASE.DETAIL(id, BASE_DETAIL_TAB_STRING.DETAIL))
    } else if (index === 1) {
      history.push(RoutesConstants.MASTER_DATA.BASE.DETAIL(id, BASE_DETAIL_TAB_STRING.OPS_TEAM))
    } else if (index === 2) {
      history.push(RoutesConstants.MASTER_DATA.BASE.DETAIL(id, BASE_DETAIL_TAB_STRING.TEAM_DRONE))
    } else if (index === 3) {
      history.push(RoutesConstants.MASTER_DATA.BASE.DETAIL(id, BASE_DETAIL_TAB_STRING.LOG))
    } else {
      history.push(RoutesConstants.MASTER_DATA.BASE.DETAIL(id, BASE_DETAIL_TAB_STRING.DETAIL))
    }
  }

  const tabComponents = () => {
    const labels = [t("sub_header_detail_base"), t("menu_ops_team"), t("label_team_drone"), t("label_log")]
    const components = [
      <MasterBaseTabDetail id={id} key={BASE_DETAIL_TAB_STRING.DETAIL} />,
      <MasterBaseTabOpsTeam id={id} key={BASE_DETAIL_TAB_STRING.OPS_TEAM} />,
      <MasterBaseTabDrone id={id} key={BASE_DETAIL_TAB_STRING.TEAM_DRONE} />,
      <TabLog
        id={id}
        historyTabEnum={ENUM_LOG.BASE}
        key={BASE_DETAIL_TAB_STRING.LOG}
      />
    ]

    return {
      labels,
      components
    }
  }

  return (
    <div>
      <TabsComponent
        labelTab={tabComponents().labels}
        componentTab={tabComponents().components}
        changeTab={handleTabChange}
        initValue={tabActive}
      />
    </div>
  )
}